import React from "react"
import styles from "./FloatingCta.module.css"

type FloatingCtaProps = {
    label: string
    onClick: () => void
    /** クリック計測用ラベル（data-click-label） */
    analyticsLabel: string
    /** true のときフェードアウトして非表示にする */
    hidden?: boolean
    className?: string
}

export default function FloatingCta({
    label,
    onClick,
    analyticsLabel,
    hidden = false,
    className,
}: FloatingCtaProps) {
    return (
        <div
            className={`${styles.wrapper} ${hidden ? styles.isHidden : ""} ${className ?? ""}`}
            aria-hidden={hidden}
        >
            <button
                type="button"
                className={styles.button}
                onClick={onClick}
                tabIndex={hidden ? -1 : 0}
                data-click-label={analyticsLabel}
            >
                <span>{label}</span>
                <svg
                    className={styles.icon}
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                >
                    <path
                        d="M3.5 6L8 10.5L12.5 6"
                        stroke="currentColor"
                        strokeWidth="1.6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </button>
        </div>
    )
}
